/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadPlatformFeaturesQueryResponse, SocialExportGetUploadPlatformFeaturesPathParams, SocialExportGetUploadPlatformFeatures401, SocialExportGetUploadPlatformFeatures403, SocialExportGetUploadPlatformFeatures404 } from "../models/SocialExportGetUploadPlatformFeatures";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetUploadPlatformFeatures } from "../axios/socialExportGetUploadPlatformFeatures";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetUploadPlatformFeaturesQueryKey = (id: SocialExportGetUploadPlatformFeaturesPathParams["id"]) => ["api-v2", { url: '/social-export/v1/upload/:id/platform-features', params: {id:id} }] as const

export type SocialExportGetUploadPlatformFeaturesQueryKey = ReturnType<typeof socialExportGetUploadPlatformFeaturesQueryKey>

export function socialExportGetUploadPlatformFeaturesQueryOptions(id: SocialExportGetUploadPlatformFeaturesPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetUploadPlatformFeaturesQueryKey(id)
        return queryOptions<SocialExportGetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<SocialExportGetUploadPlatformFeatures401 | SocialExportGetUploadPlatformFeatures403 | SocialExportGetUploadPlatformFeatures404>, SocialExportGetUploadPlatformFeaturesQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetUploadPlatformFeatures(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns which platform-specific actions are available for the upload based on connection capabilities and state.
 * @summary Get available platform features for an upload
 * {@link /social-export/v1/upload/:id/platform-features}
 */
export function useSocialExportGetUploadPlatformFeatures<TData = SocialExportGetUploadPlatformFeaturesQueryResponse, TQueryData = SocialExportGetUploadPlatformFeaturesQueryResponse, TQueryKey extends QueryKey = SocialExportGetUploadPlatformFeaturesQueryKey>(id: SocialExportGetUploadPlatformFeaturesPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<SocialExportGetUploadPlatformFeatures401 | SocialExportGetUploadPlatformFeatures403 | SocialExportGetUploadPlatformFeatures404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetUploadPlatformFeaturesQueryKey(id)
         

         const query = useQuery({
          ...socialExportGetUploadPlatformFeaturesQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetUploadPlatformFeatures401 | SocialExportGetUploadPlatformFeatures403 | SocialExportGetUploadPlatformFeatures404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}